module.exports = __webpack_public_path__ + "static/media/SPESAC.0992677a.svg";